import { render, staticRenderFns } from "./BaseDialogConfirm.vue?vue&type=template&id=4d70af59&scoped=true"
import script from "./BaseDialogConfirm.vue?vue&type=script&lang=js"
export * from "./BaseDialogConfirm.vue?vue&type=script&lang=js"
import style0 from "./BaseDialogConfirm.vue?vue&type=style&index=0&id=4d70af59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d70af59",
  null
  
)

export default component.exports